/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AgencyAPI {

  /**
   * Method that creates an agency
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiAgency(
    requestBody: {
      id?: number;
      name?: string;
      representative_id: number;
      account_manager_id?: number | null;
      delivery_fee_active?: boolean;
      media_fees_active?: boolean;
      extra_tag_price?: number | null;
      extra_site_price?: number | null;
      credit?: number | null;
      credit_cad?: number | null;
      credit_currency_id?: string;
      stripe_user_id?: string | null;
      ui_configuration_id?: number | null;
      parent_id?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    representative_id: number;
    account_manager_id: number | null;
    delivery_fee_active: boolean;
    media_fees_active: boolean;
    extra_tag_price: number | null;
    extra_site_price: number | null;
    credit: number | null;
    credit_cad: number | null;
    credit_currency_id: string;
    stripe_user_id: string | null;
    ui_configuration_id: number | null;
    parent_id: number | null;
    representative: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    };
    account_manager: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    } | null;
    currency: {
      id: string;
      exchange_rate: number;
      updated_at: string | null;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/agency',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates an agency
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiAgency(
    requestBody: {
      id: number;
      name?: string;
      representative_id?: number;
      account_manager_id?: number | null;
      delivery_fee_active?: boolean;
      media_fees_active?: boolean;
      extra_tag_price?: number | null;
      extra_site_price?: number | null;
      credit?: number | null;
      credit_cad?: number | null;
      credit_currency_id?: string;
      stripe_user_id?: string | null;
      ui_configuration_id?: number | null;
      parent_id?: number | null;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    representative_id: number;
    account_manager_id: number | null;
    delivery_fee_active: boolean;
    media_fees_active: boolean;
    extra_tag_price: number | null;
    extra_site_price: number | null;
    credit: number | null;
    credit_cad: number | null;
    credit_currency_id: string;
    stripe_user_id: string | null;
    ui_configuration_id: number | null;
    parent_id: number | null;
    representative: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    };
    account_manager: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    } | null;
    currency: {
      id: string;
      exchange_rate: number;
      updated_at: string | null;
    };
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/agency',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns the user's current agency
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgencyCurrent(): CancelablePromise<{
    id: number;
    name: string;
    representative_id: number;
    account_manager_id: number | null;
    delivery_fee_active: boolean;
    media_fees_active: boolean;
    extra_tag_price: number | null;
    extra_site_price: number | null;
    credit: number | null;
    credit_cad: number | null;
    credit_currency_id: string;
    stripe_user_id: string | null;
    ui_configuration_id: number | null;
    parent_id: number | null;
    representative: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    };
    account_manager: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    } | null;
    currency: {
      id: string;
      exchange_rate: number;
      updated_at: string | null;
    };
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/current',
    });
  }

  /**
   * Method that returns a particular agency
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgency(
    id: number,
  ): CancelablePromise<{
    id: number;
    name: string;
    representative_id: number;
    account_manager_id: number | null;
    delivery_fee_active: boolean;
    media_fees_active: boolean;
    extra_tag_price: number | null;
    extra_site_price: number | null;
    credit: number | null;
    credit_cad: number | null;
    credit_currency_id: string;
    stripe_user_id: string | null;
    ui_configuration_id: number | null;
    parent_id: number | null;
    representative: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    };
    account_manager: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    } | null;
    currency: {
      id: string;
      exchange_rate: number;
      updated_at: string | null;
    };
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns the current balance for an agency
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgencyCurrentBalance(
    id: number,
  ): CancelablePromise<{
    cad_total_debit: number;
    cad_total_credit: number;
    cad_balance: number;
    currency_balance: number;
    currency_id: 'CAD' | 'EUR' | 'USD';
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/{id}/current-balance',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that updates restrictions for an agency
   * @param id
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiAgencyRestriction(
    id: number,
    requestBody?: Array<{
      agency_id: number;
      entity_type: string;
      entity_id: string;
    }>,
  ): CancelablePromise<Array<{
    agency_id: number;
    entity_type: string;
    entity_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/agency/{id}/restriction',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns restrictions for a particular agency
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgencyRestrictions(
    id: number,
  ): CancelablePromise<Array<{
    agency_id: number;
    entity_type: string;
    entity_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/{id}/restrictions',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of agencies
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgencyList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
  ): CancelablePromise<Array<{
    id: number;
    name: string;
    representative_id: number;
    account_manager_id: number | null;
    delivery_fee_active: boolean;
    media_fees_active: boolean;
    extra_tag_price: number | null;
    extra_site_price: number | null;
    credit: number | null;
    credit_cad: number | null;
    credit_currency_id: string;
    stripe_user_id: string | null;
    ui_configuration_id: number | null;
    parent_id: number | null;
    representative: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    };
    account_manager: {
      id: number;
      firstname: string | null;
      lastname: string | null;
    } | null;
    currency: {
      id: string;
      exchange_rate: number;
      updated_at: string | null;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
      },
    });
  }

  /**
   * Method that returns a list of available agencies
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAgencyListAvailable(): CancelablePromise<Array<{
    id: number;
    parent_id?: number | null;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/agency/list/available',
    });
  }

}
